import { TaskDetailsModel } from '@alfresco/adf-process-services';

export enum SnackbarType {
  'success' = 'success',
  'error' = 'error',
}

export class SnackbarDataModel {
  type: SnackbarType;
  message: string;
  action: string;
  duration: number;
  task: TaskDetailsModel;
  error: Error;
}
